import { GetPurchase } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const fetchAllPurchase = () => {
    return dispatch => {
        dispatch({type:"PURCHASE_ACTION_START"})
        GetPurchase().then((result)=>{
            dispatch({
                type: "PURCHASE_FETCH_DATA",
                payload: result.data.purchases || result.data.Purchase || []
            }) 
        }).catch((error)=>{
            dispatch({
                type: "PURCHASE_FETCH_DATA_FAILED",
                payload: error.response?.data?.error
            }) 
        });
    }
}